/**
 * /api/entities — CRUD för entities.
 *
 * Status: Infrastruktur. Används inte av EntityService än. När produktägaren
 * migrerar EntityService till backend-mode ska wiring ske genom:
 *   if (config.isBackendMode) return entitiesApi.listEntities();
 *   else return storage.getJSON(ENTITIES_KEY) || [];
 */

import { http } from './httpClient';

export async function listEntities() {
  const result = await http.get('/entities');
  return result.data;
}

export async function getEntity(id) {
  const result = await http.get(`/entities/${encodeURIComponent(id)}`);
  return result.data;
}

export async function createEntity(payload) {
  const result = await http.post('/entities', payload);
  return result.data;
}

export async function updateEntity(id, patch) {
  const result = await http.patch(`/entities/${encodeURIComponent(id)}`, patch);
  return result.data;
}

export async function deleteEntity(id) {
  await http.delete(`/entities/${encodeURIComponent(id)}`);
}
